/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_No_Entry_For_MonthInputs */



/**
* | output |
* | --- |
* | "Not accrued yet" |
*
* @param {Partner_Admin_Commission_No_Entry_For_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_no_entry_for_month = /** @type {((inputs?: Partner_Admin_Commission_No_Entry_For_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_No_Entry_For_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht aufgelaufen")
	return /** @type {LocalizedString} */ ("Not accrued yet")
});